import React, { useEffect } from 'react';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { Edit, Mail, Pencil } from '@insurancemenu/imenu-components-lib/dist/icons';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import SubscriberStatus from 'components/common/election/SubscriberStatus';
import EditEmployersModal from 'components/group-info/EditEmployersModal';
import clsx from 'clsx';
import { UserStatus } from 'types/userService';
import { createStyles } from './styles';

type EditableType = 'NONE' | 'ICON' | 'BUTTON';

interface AdditionalAccessProps {
  groupId: string;
  editableType: EditableType;
  className?: string;
}

const AdditionalAccess = observer(({ groupId, editableType, className }: AdditionalAccessProps): JSX.Element => {
  const classes = createStyles();

  const {
    additionalAccessStore: { getEmployersForGroup, groupEmployers, loading, openEditEmployersModal },
    groupSidebarStore: {
      group: { contactInfo },
    },
  } = useRootStore();

  useEffect(() => {
    if (groupId) {
      void getEmployersForGroup(groupId);
    }
  }, [groupId]);

  const convertedGroupEmployers = groupEmployers?.map((employer) => toJS(employer)).slice();

  const currentAdmin = convertedGroupEmployers.find(({ email }) => email === contactInfo?.primaryEmail);
  const sortedEmployers =
    currentAdmin?.status === UserStatus.INVITED
      ? [currentAdmin, ...convertedGroupEmployers.filter(({ email }) => email !== contactInfo.primaryEmail)]
      : convertedGroupEmployers;

  const isEmployersListEmpty = sortedEmployers.length === 0;

  const employersList = sortedEmployers.map(({ id, firstName, lastName, status }) => {
    return (
      <div className={classes.employerWrapper} key={id}>
        <p className={classes.employerName}>{`${firstName} ${lastName}`}</p>
        <SubscriberStatus status={status} size="small" />
      </div>
    );
  });

  return (
    <>
      <div className={clsx(classes.contentWrapper, className)} id="additional-access-section">
        <header className={classes.categoryWrapper}>
          <h3 className={classes.categoryName}>Group Access</h3>
          {editableType === 'ICON' && !loading && (
            <Button
              type="text"
              iconSize="1.6rem"
              color="custom"
              customColor={colors.neutral[900]}
              leftIconProp={<Edit />}
              className={classes.editButton}
              onClick={openEditEmployersModal}
              id="edit-employers-info"
            >
              {' '}
            </Button>
          )}
        </header>
        {!loading && <div>{employersList}</div>}
        {editableType === 'BUTTON' && !loading && (
          <Button
            type="text"
            size="medium"
            color="primary"
            customColor={colors.neutral[900]}
            leftIconProp={isEmployersListEmpty ? <Mail /> : <Pencil />}
            className={classes.manageEmployersButton}
            onClick={openEditEmployersModal}
            id="manage-employers"
          >
            {isEmployersListEmpty ? 'Invite Group' : 'Manage Group Access'}
          </Button>
        )}
      </div>
      <EditEmployersModal groupId={groupId} />
    </>
  );
});

export default AdditionalAccess;
